var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatorHubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8221 1.64224C13.5823 0.626018 15.7509 0.626019 17.511 1.64224L24.1389 5.46887C25.8991 6.48509 26.9834 8.36315 26.9834 10.3956V18.0489C26.9834 20.0813 25.8991 21.9594 24.1389 22.9756L17.511 26.8022C15.7509 27.8184 13.5823 27.8184 11.8221 26.8022L5.1942 22.9756C3.43405 21.9594 2.34975 20.0813 2.34975 18.0489V10.3956C2.34975 8.36315 3.43405 6.48509 5.1942 5.46887L11.8221 1.64224Z",
    fill: "url(#paint0_linear_167_3611)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7421 16.8297C15.7421 17.9835 15.2402 19.0265 14.4384 19.737C13.7475 20.3628 12.8349 20.7409 11.831 20.7409C9.6734 20.7409 7.91992 18.9874 7.91992 16.8297C7.91992 15.5221 8.56873 14.3622 9.55792 13.6536C9.73332 13.528 9.9721 13.613 10.0687 13.8059C10.6873 15.0414 11.8121 15.9657 13.1478 16.3278C13.5584 16.4451 13.9887 16.5038 14.4384 16.5038C14.7447 16.5038 15.0384 16.4758 15.3241 16.4241C15.5294 16.387 15.7335 16.5183 15.7404 16.7268C15.7416 16.7613 15.7421 16.7957 15.7421 16.8297Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3496 11.6147C18.3496 12.1232 18.2518 12.6121 18.0758 13.0553C17.626 14.1895 16.6613 15.063 15.4684 15.3889C15.1425 15.4802 14.797 15.5258 14.4385 15.5258C14.0799 15.5258 13.7345 15.4802 13.4085 15.3889C12.2156 15.063 11.2509 14.1895 10.8011 13.0553C10.6251 12.6121 10.5273 12.1232 10.5273 11.6147C10.5273 9.45709 12.2808 7.70361 14.4385 7.70361C16.5961 7.70361 18.3496 9.45709 18.3496 11.6147Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9571 16.8297C20.9571 18.9874 19.2036 20.7409 17.046 20.7409C16.5752 20.7409 16.1217 20.6576 15.7032 20.5037C15.4757 20.42 15.4333 20.1299 15.5895 19.9445C16.3172 19.0805 16.7201 17.98 16.7201 16.8297C16.7201 16.6081 16.7005 16.3865 16.6679 16.1779V16.1779C16.6485 16.0576 16.7099 15.9394 16.8165 15.8805C17.6697 15.4081 18.3683 14.6872 18.8085 13.8065C18.905 13.6134 19.144 13.5282 19.3195 13.6539C20.3085 14.3625 20.9571 15.5223 20.9571 16.8297Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_167_3611",
    x1: 4.10986,
    y1: 8.29631,
    x2: 28.8811,
    y2: 8.2644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#FF8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#8745C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A94FB0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorHubLogo);
export default __webpack_public_path__ + "static/media/CreatorHubLogo.c7cee03a8c38dd7b80910dd2f1a28e21.svg";
export { ForwardRef as ReactComponent };